import { Gray } from '@constants/color';
import { css } from '@emotion/react';

export const footerContainer = css({
  display: 'flex',
  flexDirection: 'column',
  fontSize: '12px',
  alignItems: 'center',
  color: Gray.Gray50,
  marginBlock: '30px',
  gap: '10px'
});

export const footer = css({
  color: Gray.Gray30,
  textDecoration: 'none',
  fontSize: '13px',
  marginRight: '10px'
});

export const boldFooter = css({
  fontWeight: '700',
  paddingRight: '10px',
  borderRight: `1px solid ${Gray.Gray30}`
});
